import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIImage from 'UIComponents/image/UIImage';
import iconsUrls from '../images/iconsUrls';
import { ExternalLinkIcon } from './ExternalLinkIcon';
const StyledEmailClientButton = styled(UIButton).withConfig({
  displayName: "EmailClientButton__StyledEmailClientButton",
  componentId: "sc-2d8hqs-0"
})(["&&&{display:flex !important;margin:0 auto !important;align-items:center !important;border:none;color:white;padding:10px;width:230px;justify-content:space-between;box-shadow:0 2px 2px -1px rgba(0,0,0,0.2);}&.client-gmail{background:#dc212e;&:hover{background:#e7626b;}}&.client-yahoo{background:#6900da;&:hover{background:#9532ff;}}"]);
const EmailClientIcon = styled(UIImage).withConfig({
  displayName: "EmailClientButton__EmailClientIcon",
  componentId: "sc-2d8hqs-1"
})(["&&&{width:20px;height:20px;}"]);

const EmailClientButton = props => {
  const {
    emailClient,
    children
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["emailClient", "children"]);

  return /*#__PURE__*/_jsxs(StyledEmailClientButton, Object.assign({
    className: `client-${emailClient}`,
    use: "tertiary-light"
  }, rest, {
    children: [/*#__PURE__*/_jsx(EmailClientIcon, {
      src: iconsUrls.get(emailClient)
    }), children, /*#__PURE__*/_jsx(ExternalLinkIcon, {})]
  }));
};

export default EmailClientButton;